module.exports = __webpack_public_path__ + "img/P23-en.a12aaba6.png";